import { DetailsListLayoutMode, IColumn, IGroup, IObjectWithKey, SelectionMode } from "@fluentui/react";
import { RootState } from "app/store";
import CustomPanel from "components/controls/CustomPanel";
import { onRenderColumnCurrency } from "components/controls/Grid";
import {
    bcbs_config_attributeid_BCCAdmin,
    bcbs_config_attributeid_BillGroup, bcbs_config_attributeid_CoverageList, bcbs_config_attributeid_FeeType, pepmFeeType, pepmPerTierFeeType
} from "global/Application";
import { groupByWithAggregateFlat, TGroupByAggregate, TGroupByAggregateMethod } from "global/Utility/TSFunctions";
import { useMemo } from "react";
import { connect, ConnectedProps } from "react-redux";
import {
    IBooleanValue as FAM_IBooleanValue,
    IEntityReferenceValue as FAM_IEntityReferenceValue,
    IFeesAndPremiums as FAM_IFeesAndPremiums,
    IStringValue as FAM_IStringValue
} from "../../model/FlexibleAttributeModel";


import { StickyDetailsList } from "../../components/layout/StickyDetailList";
import { IFeesAndPremiums, IGroupConfigurationConfig } from "../../model/FlexibleAttributeModel";
import { $att_$fees_and_premiums_$bcbs_attributeset_fee_id } from "model/ConfigAttributeConstants";
interface IItem extends IObjectWithKey {
    category?: string;
    feeTypeName: string;
    'Family Rate': string;
    "Employee Only Rate": string;
    "Employee + Child(ren) Rate": string;
    "Employee + Spouse Rate": string;
    "Employee + 1 (Child) Rate": string;
    "Two-Person Rate": string;
    "Employee + 2 Dependents Rate": string;
    "Concession Amount": string;
    "billGroup": boolean;
}



interface IProps extends TComponentConnectedProps {
    feesAndPremium: FAM_IFeesAndPremiums;
    variant?: "rate"
}

export const aggregateDataForFees = (configC: IGroupConfigurationConfig, feesAndPremium: IFeesAndPremiums) => {
    const groups: IGroup[] = [];
    const rows: IItem[] = [];

    // fee config:
    const attributeFee = configC.cache.map_bcbs_config_attribute[$att_$fees_and_premiums_$bcbs_attributeset_fee_id];

    feesAndPremium.attributeSets.forEach(eachAttribute => {

        if (eachAttribute.deactivated)
            return;

        // defaults
        const item: IItem = {
            key: eachAttribute.id,
            billGroup: false,
        } as IItem;

        // Extract
        // ----------------------
        // Pick only FEE attribute set
        if (eachAttribute.attributeSetRef.id !== attributeFee._bcbs_config_masterattributeid_value)
            return;

        // Transform
        // ----------------------
        eachAttribute.fields.forEach(eachField => {
            const config = configC.cache.map_bcbs_config_attribute[eachField.configRef.id];

            if (config.bcbs_config_attributeid === bcbs_config_attributeid_BCCAdmin) {
                const value = eachField?.values?.[0]?.value as FAM_IEntityReferenceValue;

                if (value) {
                    // lets find the category selected in bcc admin
                    const bccAdmin = configC.cache.map_bcbs_bccadmin[value.id];

                    if (!bccAdmin) {
                        debugger;
                        console.log('Missing bccAdmin ', eachField.id);
                    }

                    if (bccAdmin?._bcbs_categoryid_value) {
                        const category = configC.cache.map_bcbs_config_category[bccAdmin._bcbs_categoryid_value!];
                        if (category)
                            item.category = category.bcbs_name;
                    }
                }

            } else if (config.bcbs_config_attributeid === bcbs_config_attributeid_BillGroup) {

                const value = eachField?.values?.[0]?.value as FAM_IBooleanValue;
                if (value)
                    item.billGroup = value.value;

            } else if (config.bcbs_config_attributeid === bcbs_config_attributeid_FeeType) {

                const value = eachField?.values?.[0]?.value as FAM_IEntityReferenceValue;
                if (value)
                    item.feeTypeName = value.name;

            } else if (bcbs_config_attributeid_CoverageList.includes(config.bcbs_config_attributeid!)) {

                const property = config.bcbs_name as (keyof typeof item);
                const value = eachField?.values?.[0]?.value as FAM_IStringValue;
                if (value)
                    (item[property] as string) = value.value;
            }
        });


        // Load
        // ----------------------
        rows.push(item);
    });

    const aggSum: TGroupByAggregateMethod<IItem> = (prev, current, key, row): string => {
        const prevInt = prev ? parseFloat(prev as string) : 0;
        const currentInt = current ? parseFloat(current as string) : 0;

        // we are excluding 'Per Employee Per Month (PEPM)' from aggregate
        if (row.feeTypeName !== pepmFeeType.name && row.feeTypeName !== pepmPerTierFeeType.name)
            return (prevInt).toString();

        // if bill group is Yes?
        if (row.billGroup) {
            return (prevInt + currentInt).toString();
        }
        // 'Concession Amount' ignores bill group in the condition
        if (key === 'Concession Amount') {
            return (prevInt + currentInt).toString();
        }

        return (prevInt).toString();
    };

    // const aggNoOp = (prev: string, current: string, row: any): string => {
    //     return '';
    // };

    // const aggLastString = (prev: string, current: string, row: any): string => {
    //     return current;
    // };

    const aggPredicate: TGroupByAggregate<IItem> = {
        "Employee Only Rate": aggSum,
        'Family Rate': aggSum,
        "Employee + Child(ren) Rate": aggSum,
        "Employee + Spouse Rate": aggSum,
        "Employee + 1 (Child) Rate": aggSum,
        "Two-Person Rate": aggSum,
        "Employee + 2 Dependents Rate": aggSum,
        "Concession Amount": aggSum,
    }

    const result = groupByWithAggregateFlat(rows, ['category'], aggPredicate);

    const agg = result.map(q => {
        return {
            key: q.key,
            category: q.group[0],
            ...(q.aggregate)
        }
    })
    // const sumAgg = (prev: string, current: string): string => {
    //     return ((prev ? parseInt(prev) : 0) + parseInt(current)).toLocaleString();
    // };
    // const aggPredicate = {
    //     'Family Rate': sumAgg
    // }
    // // todo change this to reduce
    // const agg1Values = {} as any;
    // debugger;
    // rows.forEach(er => {
    //     const agg1 = 'category'
    //     const agg1RowValue = er[agg1]!

    //     const isNew = agg1Values[agg1RowValue];

    //     for (const [key, value] of Object.entries(aggPredicate)) {
    //         const prevValueObj = agg1Values[agg1RowValue];
    //         const prevValue = prevValueObj ? prevValueObj[key] : null;
    //         const currValue = er[key];
    //         const predicate = value;

    //         agg1Values[agg1RowValue] = { [key]: predicate(prevValue, currValue) };
    //     }

    // })


    return {
        groups: groups,
        items: agg
    };

};

const MonthlyRecurringFees = (props: IProps) => {

    const dataSource = useMemo(() => {

        return aggregateDataForFees(props.state.data.config, props.feesAndPremium);

    }, [props.feesAndPremium.attributeSets])

    const columns = useMemo(() => {
        const columns: IColumn[] = [];

        columns.push({
            key: 'category',
            name: 'Category',
            fieldName: 'category',
            minWidth: 100,
            isResizable: true,
        });

        bcbs_config_attributeid_CoverageList.forEach(e => {
            const configAttribute = props.state.data.config.cache.map_bcbs_config_attribute[e];
            columns.push({
                key: configAttribute.bcbs_config_attributeid!,
                name: configAttribute.bcbs_name!,
                fieldName: configAttribute.bcbs_name,
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? 150,
                isResizable: true,
                onRender: onRenderColumnCurrency,
            })
        })

        return columns;
    }, []);

    return <CustomPanel title={props.variant === 'rate' ? 'Rates' : 'Monthly Recurring Fees'}
        canCollapse={true}
        defaultCollapsed={false}
        storageId={'MonthlyRecurringFees'}
    >
        <StickyDetailsList
            items={dataSource.items}
            // groups={dataSource.groups}
            columns={columns}
            selectionMode={SelectionMode.none}
            layoutMode={DetailsListLayoutMode.fixedColumns}
            groupProps={{
                showEmptyGroups: true,
            }}
        />
    </CustomPanel>
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(MonthlyRecurringFees);
